import styled from 'styled-components';

export const InputGroup = styled.div`
  display: flex;
`;

export const Input = styled.input`
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '34px'};
  padding: 0.5rem;
  margin: ${({ margin }) => margin || '0 0 1rem'};
  border: 1px solid transparent;
  border-radius: 4px;

  @media screen and (max-width: 576px) {
    width: 100%;
  }
`;
